/**
 * Create by jiangjijing on 2020/3/2
 */
import md5 from 'js-md5'
import { myToast } from '../components/myToast.js'
import router from '../router'

// 引用axios
import axios from './axios'
let Base64 = require('js-base64').Base64
// 自动配置环境
// console.log( process.env);
axios.defaults.baseURL = process.env.BASE_API
var root = process.env.ROOT // 开发网关
var templetRoot = process.env.BASE_API // 模板地址
var downloadRoot = process.env.DOWNLOAD_ROOT // 下载地址
var localRoot = process.env.LOCTL_ROOT // 本地调试
var salt = 'QAZWSXEDCRFV09876543210'

// eslint-disable-next-line no-extend-native
Date.prototype.format = function (format) {
  var o = {
    'M+': this.getMonth() + 1, // month
    'd+': this.getDate(), // day
    'h+': this.getHours(), // hour
    'm+': this.getMinutes(), // minute
    's+': this.getSeconds(), // second
    'q+': Math.floor((this.getMonth() + 3) / 3), // quarter
    'S': this.getMilliseconds() // millisecond
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length))
    }
  }
  return format
}

// 前端生成uuid
// eslint-disable-next-line camelcase
function get_uuid () {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4'
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
  s[8] = s[13] = s[18] = s[23] = '-'
  var uuid = s.join('')
  return uuid
}
// token校验与加密
function sign (p, url) {
  var token
  var sign
  var reqId = get_uuid()
  if (url == '/merrycar/web/merrycar/web/user/login') {
    token = ''
  } else {
    token = sGetObject('token')
  }
  var time = new Date().getTime()
  var cr = {
    token: token,
    time: time,
    reqData: JSON.stringify(p)
  }
  // 排序key
  var keyArr = []
  for (var item in cr) {
    if (item != 'sign') {
      keyArr.push(item)
    }
  }
  keyArr.sort()
  // 生成加密
  var content = ''
  for (var i = 0; i < keyArr.length; i++) {
    var key = keyArr[i]
    var value = cr[key]
    content += key + value
  }
  sign = md5(content).toUpperCase()
  var signData = {
    token: token,
    reqId: reqId,
    reqTime: time,
    reqData: p,
    sign: sign,
    url: url
  }
  return signData
}
/*
  接口处理函数
  全局配置调用方法
*/

function apiAxios (method, url, params, success, failure) {
  if (params) {
    if (method === 'GET') {
      params = {
        params: Base64.encode(JSON.stringify(sign(params, url)))
      }
    } else {
      params = sign(params, url)
    }
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: root,
    withCredentials: false,
    isShowLoading: false
  })
    .then(function (res) {
      if (res.data.repCode === '000000') {
        if (success !== 'success') {
          success(res.data)
        } else {
          myToast({
            type: 'success',
            message: res.data.repMsg,
            duration: 2000
          })
        }
      } else if (res.data.repCode === '000125') {
        myToast({
          type: 'error',
          message: '登录过期',
          duration: 2000
        })
        setTimeout(function () {
          sessionStorage.clear()
          router.push('/')
        }, 2000)
      } else {
        myToast({
          type: 'error',
          message: res.data.repMsg,
          duration: 2000
        })
        failure()
      }
    })
    .catch((err) => {
      if (failure) {
        failure(err.data)
      }
    })
}

/// 本地数据调用////
function localApiAxios (method, url, params, success, failure) {
  if (params) {
    params = sign(params, url)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: localRoot,
    withCredentials: false,
    isShowLoading: false
  })
    .then(function (res) {
      if (success) {
        success(res.data)
      }
    })
    .catch(function (err) {
      if (failure) {
        failure(err.data)
        myToast({
          type: 'error',
          message: JSON.stringify(err.data.repMsg),
          duration: 2000
        })
      }
    })
}

function sGetObject (k) {
  try {
    var v = sessionStorage.getItem(k)
    return v == null ? null : JSON.parse(v)
  } catch (e) { }
};

// 获取参数的方法
function getArgument (url) {
  url = url.toString()
  var res = {}
  var arr1 = url.split('?')
  if (arr1.length < 2) {
    return res
  }
  var arr2 = arr1[1].split('&')
  var arr3 = []
  for (var i = 0; i < arr2.length; i++) {
    arr3 = arr2[i].split('=')
    res[arr3[0]] = arr3.length > 0 ? arr3[1] : undefined
  }
  return res
}

// 返回在vue模板中的调用接口
export default {
  // 获取基础参数
  getSignData: function (data) {
    return sign(data)
  },
  // 获取地址
  getBaseUrl: function () {
    return root
  },
  // 获取模板地址
  getTemplateUrl: function () {
    return templetRoot
  },
  // 获取下载地址
  getDownloadUrl: function () {
    return downloadRoot
  },
  // 获取salt
  getSalt: function () {
    return salt
  },
  // 获取参数的方法
  getArgument: function (url) {
    return getArgument(url)
  },

  localGet: function (url, params, success, failure) {
    return localApiAxios('GET', url, params, success, failure)
  },
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },
  put: function (url, params, success, failure) {
    return apiAxios('PUT', url, params, success, failure)
  },
  delete: function (url, params, success, failure) {
    return apiAxios('DELETE', url, params, success, failure)
  },
  sSetObject: function (k, v) {
    try {
      sessionStorage.setItem(k, JSON.stringify(v))
    } catch (e) { }
  },
  sGetObject: function (k) {
    try {
      var v = sessionStorage.getItem(k)
      return v == null ? null : JSON.parse(v)
    } catch (e) { }
  },
  sdel: function (k) {
    sessionStorage.removeItem(k)
  },
  sclear: function () {
    sessionStorage.clear()
  },
  lGetObject: function (k) {
    try {
      var v = localStorage.getItem(k)
      return v == null ? null : JSON.parse(v)
    } catch (e) { }
  },
  lSetObject: function (k, v) {
    try {
      sessionStorage.setItem(k, JSON.stringify(v))
    } catch (e) { }
  },
  lDel: function (k) {
    localStorage.removeItem(k)
  },
  lClear: function () {
    localStorage.clear()
  }

}



// WEBPACK FOOTER //
// ./src/config/apiConfig.js